export const getAuthHeaders = () => {
  const token = localStorage.getItem('token');
  return {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
  };
};

export function getSessionFetchErrorMessage(error, fallbackMessage) {
  const status = error?.response?.status;
  const bodyError = error?.response?.data?.error;
  if (status === 403) {
    if (typeof bodyError === 'string' && bodyError.trim()) return bodyError.trim();
    return 'You do not have permission to view this session.';
  }
  return fallbackMessage;
}
